// you can import modules from the theme lib or even from
// NPM packages if they support it…
//import ExampleComponent1 from "./components/ExampleComponent1";

// you can also require modules if they support it…
const Menu = require('./components/menu');
const Buttons = require('./utils/buttons');

// Some convenient tools to get you started…
import AnimateOnPageLinks from "./components/AnimateOnPageLinks";
import "./simplegallery.min.js";


// Initialise our components on jQuery.ready…
jQuery(function ($) {

    Menu.init();
    Buttons.init();
    AnimateOnPageLinks.init();

    $('#gallery').simplegallery({
        galltime: 400,
        gallcontent: '.content',
        gallthumbnail: '.thumbnail',
        gallthumb: '.thumb'
    });

    $('.product-faq .fa').click(function () {
        $(this).toggleClass("fa-minus");
        $(this).toggleClass("fa-plus");
        $(this).closest('.faq-row').find("p").slideToggle();
    });


});